export const STYLES_ROOT_FONT_SIZE_PX = 16;
export const FONT_PRIMARY = "Public Sans, sans-serif";
